import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import axios, { AxiosError, AxiosInstance } from "axios";
import authAxios from "./authInstance";
import billingApi from "../api/billing-api";
import castingMediaApi from "../api/casting-media-api";
import emailSettingsApi from "../api/email-settings-api";
import linkboardApi from "../api/linkboard-api";
import liteAgentApi from "../api/lite-agent-api";
import locationsApi from "../api/locations-api";
import profileApi from "../api/profile-api";
import suggestionsApi from "../api/suggestions-api";
import titaniumApi from "../api/titanium-api";
import userAccountApi from "../api/user-account-api";

const apiInstances: AxiosInstance[] = [
  authAxios,
  billingApi.instance,
  castingMediaApi.instance,
  emailSettingsApi.instance,
  linkboardApi.instance,
  liteAgentApi.instance,
  locationsApi.instance,
  profileApi.instance,
  suggestionsApi.instance,
  titaniumApi.instance,
  userAccountApi.instance,
];

export function useAxiosTokenRefresh() {
  const auth = useAuth();

  useEffect(() => {
    if (auth.isAuthenticated) {
      const authHeader = `${auth.user?.token_type} ${auth.user?.access_token}`;

      const interceptor = async (
        error: AxiosError & {
          config: { _retry?: boolean; headers: Record<string, string> };
        }
      ) => {
        const originalRequest = error.config;

        if (error?.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;

          const user = await auth.signinSilent();

          originalRequest.headers.Authorization = user
            ? `${user?.token_type} ${user?.access_token}`
            : authHeader;

          return axios(originalRequest);
        }

        return Promise.reject(error as AxiosError);
      };

      apiInstances.forEach((instance) => {
        instance.interceptors.response.use((response) => response, interceptor);
      });
    }
  }, [auth]);
}
